export default class PageRealisation {

	static init() {

		let swiper = document.querySelector('.swiper-stage');
		let pagination = document.querySelector('.stage-counter');
		new Swiper(swiper, {
			slidesPerView: 1,
			navigation: {
				nextEl: '.button-next',
				prevEl: '.button-prev'
			},
			pagination: {
				el: pagination,
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current.toString().padStart(2, "0") + ' / ' + total.toString().padStart(2, "0");
				}
			}
		});

	}
}